import { useTranslation } from "react-i18next";
import Spinner from "@/components/Spinner";
import { UserLoadingReason } from "../context";

interface UsersLoaderProps {
  reason: UserLoadingReason;
}

export const UsersLoader = ({ reason }: UsersLoaderProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col justify-center items-center h-64 space-y-4">
      <Spinner />
      <p className="text-sm text-muted-foreground">
        {t("users.loadingStates." + reason)}
      </p>
    </div>
  );
};
